import { asc, count } from "drizzle-orm";
import { organization, type PowerSyncDrizzleDB } from "@space/powersync";

/**
 * Shared Drizzle query builder for fetching organization counts.
 */
export function getOrganizationCountQuery(db: PowerSyncDrizzleDB) {
  return db
    .select({
      count: count(organization.id).mapWith(Number),
    })
    .from(organization);
}

/**
 * Organizaciones a las que pertenece el usuario (local-first). El stream de
 * `organizations` solo sincroniza las orgs de las que es miembro, así que leer
 * la tabla local ya devuelve "mis orgs". Usado por el selector de liga del
 * leaderboard (cada org es una liga).
 */
export function getMyOrganizationsQuery(db: PowerSyncDrizzleDB) {
  return db
    .select({ id: organization.id, name: organization.name })
    .from(organization)
    .orderBy(asc(organization.name));
}
